<template>
  <div class="cropper-image-wrap">
    <div class="cropper-image-title">车辆证件照片</div>
    <div class="cropper-image-content" v-if="computedImgList.length">
      <div class="content-wrap">
        <div class="image-left-btn">
          <span
            class="_btn"
            :class="{ disabled: disabledLeft || imgLoading }"
            @click="!imgLoading && switchPictures(-1)"
            >前一张</span
          >
        </div>

        <!-- 图片组件部分 -->
        <div class="cropper-image-box">
          <cropper-image
            ref="cropperImage"
            :imgUrl="imgUrl"
            :imgLoading.sync="imgLoading"
            @loadComplete="loadComplete"
          >
            <template slot="footerInfo">
              <div class="cropper-image-footer-info">
                <div class="footer-title" v-if="imgTitle" :title="imgTitle">
                  {{ imgTitle }}
                </div>
                <div class="footer-pagation">
                  {{ currentIndex + 1 + ' / ' + computedImgList.length }}
                </div>
              </div>
            </template>
          </cropper-image>
        </div>
        <div class="image-right-btn">
          <span
            class="_btn"
            :class="{ disabled: disabledRight || imgLoading }"
            @click="!imgLoading && switchPictures(1)"
            >后一张</span
          >
        </div>
      </div>
    </div>
    <div class="cropper-empty-text" v-else>
      <span class="text">暂无图片</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loopCropperImage',
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line vue/no-unused-properties
    colorList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      imgLoading: true,
      imgUrl: '',
      imgTitle: '',
      currentIndex: 0,
    }
  },
  computed: {
    computedImgList() {
      const arr = []
      this.imgList.forEach((item) => {
        if (item) {
          const url = this.handleImgData(item)
          const title = this.handleImgData(item, 'title')
          if (url) {
            arr.push({
              url,
              title,
            })
          }
        }
      })
      return arr
    },
    disabledLeft() {
      if (this.computedImgList.length) {
        if (this.currentIndex === 0) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    disabledRight() {
      if (this.computedImgList.length) {
        if (this.currentIndex >= this.computedImgList.length - 1) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
  },
  watch: {
    computedImgList: {
      handler(val) {
        if (val && val.length) {
          this.imgUrl = this.computedImgList[0].url
          this.imgTitle = this.computedImgList[0].title
        } else {
          this.imgUrl = ''
          this.imgTitle = ''
        }
      },
      immediate: true,
    },
    imgList: {
      handler() {
        this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    init() {
      // this.currentIndex = 0
      // this.imgUrl = ''
    },
    switchPictures(type) {
      if (this.computedImgList.length) {
        if (type === -1) {
          if (this.currentIndex <= 0) {
            return false
          } else {
            this.imgLoading = true
            this.$refs.cropperImage.clear()
            this.currentIndex--
            this.imgUrl = this.computedImgList[this.currentIndex].url
            this.imgTitle = this.computedImgList[this.currentIndex].title
          }
        } else if (this.currentIndex >= this.computedImgList.length - 1) {
          return false
        } else {
          this.imgLoading = true
          this.$refs.cropperImage.clear()
          this.currentIndex++
          this.imgUrl = this.computedImgList[this.currentIndex].url
          this.imgTitle = this.computedImgList[this.currentIndex].title
        }
      } else {
        return false
      }
    },
    loadComplete() {
      this.imgLoading = false
    },
    /**
     * 统一处理图片数据
     * 如果[]取第1个的attr值
     * data是数据源，不确定什么格式，先尝试转JSON，然后尝试获取
     * arrt是属性值，比如取url, title string格式
     */
    handleImgData(data, attr = 'url') {
      try {
        const _data = JSON.parse(data)
        if (_data instanceof Object) {
          if (Array.isArray(_data)) {
            if (_data.length) {
              return _data[0][attr]
            }
          } else {
            return _data[attr]
          }
        } else {
          return ''
        }
      } catch (error) {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// 图片组件样式
.cropper-image-wrap {
  .cropper-image-title {
    padding: 12px 0;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #333;
  }

  // 内容区域
  .cropper-image-content {
    height: 100%;

    .content-wrap {
      display: flex;
    }
    .cropper-image-box {
      display: flex;
      flex: 1;
      min-width: 0;
      // 标题和分页
      .cropper-image-footer-info {
        width: 100%;
        display: flex;
        .footer-title {
          font-size: 20px;
          text-align: center;
          max-width: 210px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .footer-pagation {
          margin-left: 10px;
          font-size: 20px;
          text-align: center;
        }
      }
    }
    .image-left-btn,
    .image-right-btn {
      display: flex;
      width: 24px;
      height: 300px;
      align-items: center;
      ._btn {
        padding: 30px 0;
        width: 24px;
        color: #333;
        border-radius: 10px;
        cursor: pointer;
        text-align: center;
        background-color: #efefef;
        user-select: none;
        &:active {
          background-color: #dfdfdf;
        }
        &.disabled {
          cursor: no-drop;
          background-color: #ccc;
          &:active {
            background-color: #ccc;
          }
        }
      }
    }
    .image-left-btn {
      margin-right: 12px;
    }
    .image-right-btn {
      margin-left: 12px;
    }
  }

  .cropper-empty-text {
    display: flex;
    min-width: 580px;
    height: 100%;
    align-items: center;
    justify-content: center;
    .text {
      margin-top: -40px;
      width: auto;
      height: 20px;
      font-weight: bold;
      font-size: 16px;
      color: #333;
    }
  }
}
</style>
